module.exports = __webpack_public_path__ + "static/media/thumb.2cb82f9a.png";